import { css } from '@emotion/css';

import { nonMobileMediaQuery } from '../../constants';
import { m, p3Css } from '../../motif';

export const breadcrumbContainerCss = css`
  overflow: hidden;
`;

export const breadcrumbCss = css`
  align-items: center;
  color: ${m('--action-default-color')};
  display: flex;
  font-size: ${m('--annotation-mobile-font-size')};
  font-weight: ${m('--annotation-mobile-font-weight')};
  gap: ${m('--spacing-xxs')};
  letter-spacing: ${m('--annotation-mobile-font-letter-spacing')};
  line-height: ${m('--annotation-mobile-font-line-height')};
  overflow: hidden;
  padding: ${m('--spacing-xs')} ${m('--spacing-xxs')};

  ${nonMobileMediaQuery} {
    font-size: ${m('--annotation-desktop-font-size')};
    font-weight: ${m('--annotation-desktop-font-weight')};
    letter-spacing: ${m('--annotation-desktop-font-letter-spacing')};
    line-height: ${m('--annotation-desktop-font-line-height')};
  }
`;

export const breadcrumbAnchorCss = css`
  text-decoration: none;

  @media (hover: hover) {
    :hover {
      color: ${m('--action-hover-color')};
    }
  }
`;

export const breadcrumbTextCss = css`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const breadcrumbActiveCss = css`
  color: ${m('--action-active-color')};
`;

export const tooltipCss = css`
  ${p3Css}
  background-color: ${m('--neutral-v625')};
  border-radius: 4px;
  color: ${m('--neutral-v0')};
  left: 50%;
  opacity: 0;
  padding: ${m('--spacing-xs')} 21px;
  position: absolute;
  top: 120%;
  transform: translateX(-50%);
  transition: opacity 200ms, visibility 200ms;
  white-space: nowrap;
  pointer-events: none;
  visibility: hidden;

  ${`.${breadcrumbContainerCss}[data-truncated="true"]`}:hover & {
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
  }

  &::before {
    border-bottom: 12px solid ${m('--neutral-v625')};
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    bottom: 100%;
    content: '';
    height: 0;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 0;
  }
`;

export const backIconCss = css`
  fill: ${m('--action-default-color')};
  margin-inline-start: calc(${m('--spacing-xxs')} * -1);

  [dir='rtl'] & {
    transform: scaleX(-1);
  }

  ${nonMobileMediaQuery} {
    display: none;
  }
`;
